/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_developer_api_keys_wizard_use_case_description = /** @type {(inputs: {}) => string} */ () => {
	return `Elige un preset que se ajuste a tu integración o comienza desde cero.`
};

const en_developer_api_keys_wizard_use_case_description = /** @type {(inputs: {}) => string} */ () => {
	return `Choose a preset that matches your integration or start from scratch.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const developer_api_keys_wizard_use_case_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.developer_api_keys_wizard_use_case_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("developer_api_keys_wizard_use_case_description", locale)
	if (locale === "es") return es_developer_api_keys_wizard_use_case_description(inputs)
	return en_developer_api_keys_wizard_use_case_description(inputs)
};
export { developer_api_keys_wizard_use_case_description as "developer.api_keys.wizard.use_case_description" }